export default __webpack_public_path__ + "media/vendors/app_store_download-05257933.svg";